exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive-size[data-v-82c35ad8]{font-size:2.5rem}@media (min-width:768px){.responsive-size[data-v-82c35ad8]{font-size:3.5rem}}", ""]);

// exports
